module.exports = __webpack_public_path__ + "static/img/animals9.c38505b2.png";